/*
 * Available language tags for the application.
 *
 * We follow a simplified version of BCP: 47 (RFC 5646)
 * - Language codes follow ISO 639-1 (2-letter codes)
 * - Regional variants follow ISO 3166-1 alpha-2 (2-letter country codes)
 * eg: "en", "en-US" "en-GB"
 *
 * https://datatracker.ietf.org/doc/html/rfc5646
 *  langtag       = language
 *                  ["-" region]
 *
 *  language      = 2*3ALPHA            ; shortest ISO 639 code
 *
 *  region        = 2ALPHA              ; ISO 3166-1 code
 */
// This is what we accept as valid language tags throughout the application
export const AVAILABLE_LANGUAGE_TAGS = [
    "en",
    "en-US",
    "en-GB",
    "fr",
    "fr-FR",
    "fr-CA",
    "nl",
    "nl-NL",
];
// This is what we use for integration with external services (e.g., Adyen)
export const SUPPORTED_TRANSLATIONS = ["en-US", "en-GB", "fr-FR", "fr-CA", "nl-NL"];
// Language code to full locale mapping (ISO 639-1 → ISO 639-1 + ISO 3166-1)
// Note: fr-CA is preserved as a distinct locale, not mapped to fr-FR
export const LANGUAGE_MAP = {
    fr: "fr-FR",
    en: "en-GB",
    nl: "nl-NL",
};
